 import headers from '@components/header'
 import footerbom from '@components/footer'
 import Message from '@components/message-box'
 let components = {
     headers,
     footerbom,
     'v-message': Message,
 }

 export default components


// WEBPACK FOOTER //
// ./src/base/api/components.js